import {jam} from '@jam.dev/sdk';
import {USE_WEBGL} from '../../app.const';
export const useJam = () => {
    jam.metadata(() => {
        const metadata: any = {
            'UI version': RELEASE_VERSION,
            WebGL: USE_WEBGL,
            Timestamp: new Date().toISOString()
        };
        if (performance) {
            metadata['Time from page load'] = performance.now() / 1000 + 's';
            const memory = (performance as any).memory;
            if (memory) {
                metadata['Heap size'] = Math.round(memory.totalJSHeapSize / 1024 / 1024) + 'MB';
                metadata['Heap used'] = Math.round(memory.usedJSHeapSize / 1024 / 1024) + 'MB';
                metadata['Heap limit'] = Math.round(memory.jsHeapSizeLimit / 1024 / 1024) + 'MB';
                metadata['Memory usage'] = Math.round((memory.usedJSHeapSize / memory.jsHeapSizeLimit) * 100) + '%';
            }
            if ((navigator as any)?.connection?.effectiveType) {
                metadata['Connection type'] = (navigator as any).connection.effectiveType;
            }
        }
        return metadata;
    });
};
